<!-- 店铺设置/商家分类列表 -->
<template>
  <el-table 
    :data="tableData" 
    style="width: 100%;border: 1px solid #f1f1f1" 
    row-key="id"
    default-expand-all
    :tree-props="{children: 'children'}"
    height="78%"
    >
    <!-- <el-table-column
      type="selection"
      width="60"
      align="center"
    ></el-table-column> -->
    <el-table-column
      label="分类名称"
      prop="name"
      align="center"
    ></el-table-column>
    <el-table-column
      label="描述"
      prop="des"
      align="center"
    ></el-table-column>
    <el-table-column
      label="状态"
      prop="show_Status"
      align="center"
    ></el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="setChild(scope.row)">添加子类</el-button>
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row.id)">删除</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    setChild(row) {
      console.log(row);
      this.$router.push({
        path: "shopClassForm",
        query: { pid: row.id }
      });
    },
    del(id) {
      console.log(id)
      this.$confirm('确定删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit("delItem", id);
      }).catch();
    },
    edit(row){
      var rowdata = {
        id: row.id,
        pid: row.pid,
        plugins_id: row.plugins_id,
        name: row.name,
        des: row.des,
        status: row.status
      }
      this.$router.push({
        path: "shopClassForm",
        query: {data:rowdata}
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.image_box {
  width: 40px;
  height: 40px;
}
</style>
